import { useTranslation } from 'react-i18next'
import { Button } from '@/components/ui/button'

type OnboardingStandardsIntroStepProps = {
  standardsWorkflowError: string | null
  onBeginStandards: () => void
}

export function OnboardingStandardsIntroStep({
  standardsWorkflowError,
  onBeginStandards,
}: OnboardingStandardsIntroStepProps) {
  const { t } = useTranslation('machineryDirectiveCompliance')

  return (
    <div className='space-y-6'>
      <div className='space-y-4'>
        <h2 className='text-lg font-semibold tracking-tight'>
          {t('onboarding.step2Standards.title')}
        </h2>
        <p className='leading-relaxed text-muted-foreground'>
          {t('onboarding.step2Standards.intro')}
        </p>
        {standardsWorkflowError && (
          <p className='text-sm text-destructive' role='alert'>
            {standardsWorkflowError}
          </p>
        )}
      </div>
      <div className='flex justify-end'>
        <Button onClick={onBeginStandards}>
          {t('onboarding.step2Standards.runCheck')}
        </Button>
      </div>
    </div>
  )
}
